import $ from 'jquery'
import './benefits.scss'

export default (benefit, label) => {
  if ($(benefit).find('.bottom .befits__section-item').length === 0) {
    $(benefit).find('.befits__section.bottom').addClass('empty')
  }

  if ($(benefit).find('.bottom .befits__section-item').length > 4) {
    $(benefit).find('.befits__section .more').css('display', 'flex')
  }
  $(benefit).find('.btn-holder').on('click', (e) => {
    e.stopPropagation()
    e.preventDefault()
    if ($(benefit).find('.btn-holder').hasClass('more')) {
      $(benefit).find('.btn-holder').removeClass('more').addClass('less')
      $(benefit).find('.btn-holder a').text(label.lessItemsText)
      $(benefit).find('.bottom .befits__section-item').addClass('show')
      $(window).scrollTop($(benefit).find('.bottom .befits__section-item').offset().top - $('.site-header').height())
    } else if ($(benefit).find('.btn-holder').hasClass('less')) {
      $(benefit).find('.btn-holder').removeClass('less').addClass('more')
      $(benefit).find('.btn-holder a').text(label.moreItemsText)
      $(benefit).find('.bottom .befits__section-item').removeClass('show')
      $(window).scrollTop($(benefit).find('.bottom .befits__section-item').offset().top - $('.site-header').height() - 10)
    }
  })
}
